const HEADER_PROPS = {
  height: 72,
};

export { HEADER_PROPS };
